const tabs = {
  'crash': [
    '103902',
    '103904',
    '103905',
    '103906',
    '103907',
    '103908',
    '103909',
    '103910',
    '103911',
    '103912',
    '103913',
    '103914',
    '103915',
    '104571',
    '104573',
    '105417',
  ]
}


export function getTab(slotName) {
  const trueTab = Object.keys(tabs).reduce(
    (acc, tab) => (tabs[tab].findIndex(item => item === slotName) === -1 ? acc : [...acc, tab]),
    ['slotMachines', 'crash'],
  );
  return trueTab;
}